import { useCallback, useEffect, useState } from "react";
import Loader from "react-loader-spinner";
import { LoadingState } from "../../../navigation/LoadingState";
import { Interval } from "../../../navigation/tabs/Tabs";
import { Area } from "../../../navigation/tree/Area";
import {Trans} from "react-i18next"
import classes from "../../Statistics.module.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import { getTopWebsites, TopWebsitesApiResponse } from "../../../api/MaintenanceRequests";

interface IProps {
    area: Area
    nodePath: string,
    startDateTimestamp: number,
    endDateTimestamp: number,
    interval: Interval,
}

export const TopWebsites = (props: IProps) => {

    const [topWebsites, setTopWebsites] = useState<TopWebsitesApiResponse|undefined>(undefined)
    const [loadingState, setLoadingState] = useState<LoadingState>(LoadingState.LOADING)

      
    const loadTopWebsites = async() => {
        setLoadingState(LoadingState.LOADING)
        const topWebsitesResponse = await getTopWebsites(props.startDateTimestamp, props.endDateTimestamp, props.nodePath, props.area.mediaspot?.serial)
        if(topWebsitesResponse.data){
            setTopWebsites(topWebsitesResponse.data)
            setLoadingState(LoadingState.LOADED)
        }else {
            setLoadingState(LoadingState.ERROR)
        }
    }

    // Each time props are updated, reload data
    useEffect(() => {
        loadTopWebsites()
    }, [props.startDateTimestamp, props.endDateTimestamp, props.nodePath, props.interval])

    return (
        <>
         {
            loadingState === LoadingState.LOADING ?
                <div className={classes.StatisticsLoaderContainer}>
                    <Loader type="Oval" color="#4185F4" height={50} width={50}/>
                </div> : null
        }
        {
            loadingState === LoadingState.ERROR ?
                <div className={classes.StatisticsErrorContainer}>
                    <label><Trans>AnErrorOccurredDuringLoading</Trans>...</label>
                    <br />
                    <button className={classes.RetryButton} onClick={() => loadTopWebsites()}><FontAwesomeIcon icon={faRedo} size={"sm"} color={"#404040"}/>&nbsp;&nbsp;<Trans>Reload</Trans></button>
                </div> : null
        }
            
        {
            loadingState === LoadingState.LOADED && topWebsites ?
                // If no data on period
                topWebsites.length === 0 ? <div className={classes.StatisticsNoDataContainer}>
                    <label><Trans>NoDataOnThisPeriod</Trans></label>
                </div> :

                <table>
                    <thead>
                        <tr>
                            <th>Site</th>
                            <th>Nombre d'accès</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            topWebsites.map(topWebsite => {
                                return (
                                    <tr>
                                        <td>{topWebsite.website}</td>
                                        <td>{topWebsite.count}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
                : undefined
            }
        </>
    )
}